import { render, staticRenderFns } from "./ReminderSelectDocuments.vue?vue&type=template&id=0e97c272&scoped=true"
import script from "./ReminderSelectDocuments.vue?vue&type=script&lang=ts"
export * from "./ReminderSelectDocuments.vue?vue&type=script&lang=ts"
import style0 from "./ReminderSelectDocuments.vue?vue&type=style&index=0&id=0e97c272&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97c272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e97c272')) {
      api.createRecord('0e97c272', component.options)
    } else {
      api.reload('0e97c272', component.options)
    }
    module.hot.accept("./ReminderSelectDocuments.vue?vue&type=template&id=0e97c272&scoped=true", function () {
      api.rerender('0e97c272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/ReminderSelectDocuments.vue"
export default component.exports